import React from 'react'
import { prussian } from 'constants/inlineStyles'

let styles = {}

const FlyersFooter = () => (
  <div className="flyerFooter" style={styles.footer}>
    <h4 style={styles.footerText}>
      &copy; {new Date().getFullYear()} Peachjar. All rights reserved.
    </h4>
  </div>
)

styles = {
  footer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '5.625rem'
  },
  footerText: { fontWeight: 'normal', color: prussian }
}
export default FlyersFooter



// WEBPACK FOOTER //
// ./src/screens/Flyers/components/FlyerFooter.js